import { AxiosInstance, AxiosResponse } from 'axios'

import { BillRequest } from 'src/models/interface/bill'

export const billsClient = (httpInstance: AxiosInstance) => ({
  getMFAOptions: async (contract: string, document: string): Promise<AxiosResponse> => {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/cliente/opcoes-mfa/?contrato=${contract}&documento=${document}`
    const response = await httpInstance.get(url)
    return response
  },
  getSecondCopyBill: async (request: BillRequest): Promise<AxiosResponse> => {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/cliente/boleto/`
    const response = await httpInstance.get(url, { params: request })
    return response
  },
  getPDF: async (contract: string, idPDF: string): Promise<AxiosResponse> => {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/cliente/boleto/${contract}/${idPDF}`
    const response = await httpInstance.get(url)
    return response
  },
  getMFA: async (request: BillRequest): Promise<AxiosResponse> => {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/cliente/mfa/`
    const response = await httpInstance.post(url, request)
    return response
  }
})
